import client from './client';

export interface RuleOutputItem {
  id: string;
  outputKey: string;
  value: unknown;
  valueType: string;
  ts: string;
  chainId?: string | null;
  ttlSec?: number;
}

export async function fetchRuleOutputs(): Promise<RuleOutputItem[]> {
  try {
    const { data } = await client.get<{ items: RuleOutputItem[] }>('/rule-outputs', { params: { _t: Date.now() } });
    return data?.items || [];
  } catch {
    return [];
  }
}

/** 规则链输出的虚拟设备 ID（3D/大屏绑定统一用此 key） */
export function ruleOutputDeviceId(outputKey: string): string {
  return `rule:${outputKey}`;
}

/** 把输出值转成可绑定点位（value + 对象标量叶 + 原 key） */
export function ruleOutputPoints(outputKey: string, value: unknown): Record<string, number | boolean | string> {
  const points: Record<string, number | boolean | string> = {};
  const scalar = (v: unknown) => typeof v === 'number' || typeof v === 'boolean' || typeof v === 'string';
  if (scalar(value)) points.value = value as number | boolean | string;
  else points.value = JSON.stringify(value ?? null);
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      if (scalar(v)) points[k] = v as number | boolean | string;
    }
  }
  if (scalar(value)) points[outputKey] = value as number | boolean | string;
  return points;
}
